import { DiscountBadge } from '@/components/cta/DiscountBadge'
import { CookieConsent } from '@/components/popups/CookieConsent'
import { FatFooter } from '@/components/layout/FatFooter'
import { SimpleNavbar } from '@/components/navbars/SimpleNavbar'
import { useQuery } from '@/utils/url'

type Props = {
  className?: string,
  lightHeader?: boolean
}

export const FatFooterLayout: React.FC<Props> = ({ className = '', children, lightHeader = false }) => {
  return (
    <div className={`${className} relative overflow-hidden`}>
      <header className={`${lightHeader ? 'bg--white' : ''} relative xl:pt-[100px] pt-[80px]`}>
        <SimpleNavbar
          light={lightHeader}
          links={[
            { href: useQuery('/accountability-coaching'), label: 'Accountability Coaching' },
            { href: useQuery('/groups'), label: 'Groups' },
            { href: useQuery('/elite-coaching'), label: 'Elite Coaching' },
            { href: useQuery('/pricing'), label: 'Pricing' },
          ]}
        />
      </header>
      <main>
        { children }
      </main>
      <FatFooter
        columns={[
          {
            title: 'Commit Action',
            links: [
              { label: 'About Us', href: useQuery('/about') },
              { label: 'See The Science', href: useQuery('/see-the-science') },
              { label: 'Success Stories', href: useQuery('/success-stories') },
              { label: 'Entrepreneur Personality Test', href: useQuery('/entrepreneur-personality-test') },
              { label: 'Frequently Asked Questions', href: useQuery('/faq') },
            ],
          },
          {
            title: 'Products',
            links: [
              { label: 'Accountability Coaching', href: useQuery('/accountability-coaching') },
              { label: 'Accountability Groups', href: useQuery('/groups') },
              { label: 'Elite Coaching', href: useQuery('/elite-coaching') },
              { label: 'Scientific Productivity Course', href: useQuery('/scientific-productivity-course') }
            ],
          },
          {
            title: 'Training',
            links: [
              { label: 'Accountability Training & Tools', href: useQuery('/training') },
              { label: 'How To Hire An Accountability Coach', href: useQuery('/how-to-hire-an-accountability-coach') },
              { label: 'ADHD Business Coaching', href: useQuery('/adhd-coaching') },
              { label: 'Time Management Coaching', href: useQuery('/time-management-efficency-coach') },
              { label: 'Accountability Partners Vs. Accountability Coaches', href: useQuery('/accountability-partner-vs-accountability-coach') }
            ],
          },
          {
            title: 'Local',
            titleHref: useQuery('/local'),
            links: [
              { label: 'Dallas Accountability Coaching', href: useQuery('/local/dallas') },
              { label: 'Los Angeles Accountability Coaching', href: useQuery('/local/los-angeles') },
              { label: 'Toronto Accountability Coaching', href: useQuery('/local/toronto') },
              { label: 'Atlanta Accountability Coaching', href: useQuery('/local/atlanta') },
              { label: 'NYC Accountability Coaching', href: useQuery('/local/new-york') },
              { label: 'Miami Accountability Coaching', href: useQuery('/local/miami') },
            ],
          },
          {
            title: 'Alternatives',
            links: [
              { label: 'Young Presidents Organization Alternative', href: useQuery('/young-presidents-organization-alternative') },
              { label: 'Vistage Alternative', href: useQuery('/vistage-alternative') },
              { label: 'Entrepreneurs Organization Alternative', href: useQuery('/entrepreneurs-organization-alternative') },
              { label: 'Tony Robbins Coaching Alternative', href: useQuery('/tony-robbins-coaching-alternative') },
            ],
          },
        ]}/>
      <CookieConsent/>
      <DiscountBadge/>
    </div>
  )
}
